import { useEffect, useState } from 'react';
import { FaStar, FaShieldAlt, FaFileContract, FaGlobe, FaCheckCircle, FaRegClock, FaBook, FaMusic, FaFilm, FaPaintBrush, FaCode, FaCopyright, FaArrowRight } from "react-icons/fa";
import { Link } from 'react-router-dom';
import LazyImg from '../../components/LazyImg';
import Meta from '../../components/Meta';
import Faq from '../../components/Faq';
import Testimonial from '../../components/Testimonial';
import headerImg from "../../assets/images/copyright_certificate.png";
import copyright from "../../assets/images/What_Copyright.png";
import importantCopyright from "../../assets/images/imporatace_copyright.png";


export default function CopyrightBody() {
  const [responsive, setResponsive] = useState(false);
  const [entity, setEntity] = useState('');
  const [mobileNumber, setMobileNumber] = useState('');
  const [city, setCity] = useState('');

  useEffect(() => {
    const onResize = () => setResponsive(window.innerWidth < 768);
    window.addEventListener('resize', onResize);
    onResize();
    return () => window.removeEventListener('resize', onResize);
  }, []);

  const fontSize = (big, small) => (responsive ? small : big);
  const vpad = (big, small) => (responsive ? small : big); // vertical spacing helper
  const hpad = (big, small) => (responsive ? small : big); // horizontal padding
  const imgSize = (big, small) => (responsive ? small : big); // image sizing helper

  // Classy color palette (Navy Blue & Gold)
  const primary = '#ef5027'; // Deep Navy Blue
  const primaryDark = '#051B2F'; // Darker Navy
  const primaryLight = '#1A4D7A'; // Lighter Navy
  const accent = '#ef5027'; // Luxury Gold
  const primaryRGBA = (a) => `rgba(10,37,64,${a})`;
  const accentRGBA = (a) => `rgba(212,175,55,${a})`;
  const primaryGradient = 'linear-gradient(135deg, rgba(10,37,64,0.12), rgba(10,37,64,0.06))';
  const subtleShadow = '0 6px 30px rgba(5,27,47,0.06)';

  const faqItems = [
    {
      title: 'Can I sue for copyright infringement without registration?',
      content: <p>Yes, you can file civil action for copyright infringement without registration, but a registered copyright under the Bangladesh Copyright Act provides stronger evidence and easier enforcement in courts.</p>
    },
    {
      title: 'Is there a separate form for copyright registration of different works?',
      content: <p>Yes. Different categories (literary, artistic, musical, sound recordings, cinematographic works, software) have appropriate application details under Bangladesh law.</p>
    },
    {
      title: 'Can I use the copyright symbol (©) without registering my work?',
      content: <p>Yes, the © symbol may be used without registration, but registration creates a public record and is recommended for enforcement.</p>
    },
    {
      title: 'What are the different types of copyright registration available?',
      content: <p>Registrations cover literary works, visual & performing arts, sound recordings, cinematographic films, software, architectural works and related categories recognised in Bangladesh.</p>
    },
    {
      title: 'Do I need a No Objection Certificate (NOC) for copyright registration?',
      content: <p>A NOC may be required for works with multiple contributors or when rights are assigned; JK Associates can advise based on your case.</p>
    },
    {
      title: 'Why should I register my copyright in Bangladesh?',
      content: <p>Registration creates an official record with the Copyright Office (Bangladesh), aids enforcement, and can be necessary for disputes, licensing and export of creative works.</p>
    }
  ];

  return (
    <main style={{ maxWidth: "100%", width: '100%', overflowX: 'hidden' }}>
      <Meta
        title="Copyright Registration in Bangladesh | JK Associates"
        description="Protect your creative works with expert Copyright Registration services in Bangladesh. Apply online with JK Associates to protect literary works, software, music, artistic works, films and sound recordings under Bangladesh law."
        keywords="copyright registration, copyright registration Bangladesh, copyright registration online, copyright protection, intellectual property, creative works Bangladesh"
      />

      {/* Hero Section with Form */}
      <section style={{
        backgroundColor: '#ffffff',
        padding: vpad('60px 40px', '40px 20px'),
        display: 'grid',
        gridTemplateColumns: responsive ? '1fr' : '1fr 1fr',
        gap: vpad('60px', '40px'),
        alignItems: 'center',
        maxWidth: '100%',
        margin: '0 auto',
        overflowX: 'hidden'
      }}>
        {/* Left Content */}
        <div>
          {/* Certification Badge */}
          <div style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: '8px',
            backgroundColor: `${primaryRGBA(0.08)}`,
            padding: '10px 16px',
            borderRadius: '20px',
            marginBottom: vpad('24px','16px'),
            fontSize: fontSize('13px', '12px')
          }}>
            <FaShieldAlt color={primary} size={16} />
            <span style={{ color: primary, fontWeight: '500' }}>Certified Firm — JK Associates</span>
          </div>

          <h1 style={{
            fontSize: fontSize('48px', '32px'),
            fontWeight: '800',
            background: `linear-gradient(135deg, ${primary} 0%, ${primaryDark} 50%, ${primaryLight} 100%)`,
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            backgroundClip: 'text',
            marginBottom: vpad('16px','12px'),
            lineHeight: 1.2,
            textShadow: `0 2px 10px ${primaryRGBA(0.1)}`,
            letterSpacing: '-0.5px'
          }}>
            Copyright Registration — Bangladesh
          </h1>

          {/* Features List */}
          <div style={{ marginBottom: vpad('32px','20px') }}>
            {[
              'Protect your creative work—from books to software—under the Bangladesh Copyright Act (2000).',
              'Get expert-assisted registration to prevent infringement and secure ownership across Bangladesh.',
              'Register online with JK Associates. Trusted by creators across Bangladesh for reliable copyright protection.'
            ].map((feature, i) => (
              <div key={i} style={{
                display: 'flex',
                gap: '12px',
                marginBottom: vpad('12px','8px'),
                fontSize: fontSize('15px', '13px'),
                color: '#23384a'
              }}>
                <FaCheckCircle color={primary} style={{ flexShrink: 0, marginTop: '4px' }} />
                <span>{feature}</span>
              </div>
            ))}
          </div>

          <Link to="/copyright-registration" style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: '8px',
            color: primary,
            textDecoration: 'none',
            fontSize: fontSize('15px', '13px'),
            fontWeight: '600'
          }}>
            Learn about Copyright registration <FaArrowRight size={14} />
          </Link>

          {/* Review Badge */}
          <div style={{
            marginTop: vpad('32px','20px'),
            padding: '20px',
            backgroundColor: `${primaryRGBA(0.03)}`,
            borderRadius: '12px',
            display: 'grid',
            gridTemplateColumns: 'repeat(3, 1fr)',
            gap: '20px',
            textAlign: 'center'
          }}>
            {[
              { icon: '⭐', text: 'Google Reviews', rating: '5/5' },
              { icon: '🏆', text: 'Trustpilot', rating: '4.8/5' },
              { icon: '⭐', text: 'Local Reviews', rating: '4.8/5' }
            ].map((badge, i) => (
              <div key={i}>
                <div style={{ fontSize: '24px', marginBottom: '4px' }}>{badge.icon}</div>
                <div style={{ fontSize: '12px', color: '#516678' }}>{badge.text}</div>
                <div style={{ fontSize: '14px', fontWeight: '600', color: primary }}>{badge.rating}</div>
              </div>
            ))}
          </div>
        </div>

        {/* Right Form */}
        <div style={{
          backgroundColor: `${primaryRGBA(0.04)}`,
          padding: vpad('32px','24px'),
          borderRadius: '12px',
          boxShadow: `0 2px 8px ${primaryRGBA(0.08)}`,
          border: `1px solid ${primaryRGBA(0.1)}`,
          maxWidth: responsive ? '100%' : 'auto',
          width: '100%'
        }}>
          <h3 style={{
            fontSize: fontSize('24px', '18px'),
            fontWeight: '700',
            marginBottom: vpad('24px','16px'),
            color: primary
          }}>
            Copyright Registration
          </h3>

          <div style={{ marginBottom: '20px' }}>
            <label style={{ display: 'block', fontSize: fontSize('13px', '12px'), fontWeight: '600', marginBottom: '8px', color: '#23384a' }}>
              Email
            </label>
            <input
              type="email"
              placeholder="you@example.com"
              style={{
                width: '100%',
                padding: fontSize('12px', '10px'),
                border: `1px solid ${primaryRGBA(0.15)}`,
                borderRadius: '6px',
                fontSize: fontSize('14px', '13px'),
                boxSizing: 'border-box',
                transition: 'border-color 0.3s',
              }}
              onFocus={(e) => e.target.style.borderColor = primary}
              onBlur={(e) => e.target.style.borderColor = primaryRGBA(0.15)}
            />
          </div>

          <div style={{ marginBottom: '20px' }}>
            <label style={{ display: 'block', fontSize: fontSize('13px', '12px'), fontWeight: '600', marginBottom: '8px', color: '#23384a' }}>
              Mobile Number
            </label>
            <input
              type="tel"
              placeholder="+880 1234567890"
              value={mobileNumber}
              onChange={(e) => setMobileNumber(e.target.value)}
              style={{
                width: '100%',
                padding: fontSize('12px', '10px'),
                border: `1px solid ${primaryRGBA(0.15)}`,
                borderRadius: '6px',
                fontSize: fontSize('14px', '13px'),
                boxSizing: 'border-box',
                transition: 'border-color 0.3s',
              }}
              onFocus={(e) => e.target.style.borderColor = primary}
              onBlur={(e) => e.target.style.borderColor = primaryRGBA(0.15)}
            />
          </div>

          <div style={{ marginBottom: '20px' }}>
            <label style={{ display: 'block', fontSize: fontSize('13px', '12px'), fontWeight: '600', marginBottom: '8px', color: '#23384a' }}>
              City/Postal Code
            </label>
            <input
              type="text"
              placeholder="Enter your city"
              value={city}
              onChange={(e) => setCity(e.target.value)}
              style={{
                width: '100%',
                padding: fontSize('12px', '10px'),
                border: `1px solid ${primaryRGBA(0.15)}`,
                borderRadius: '6px',
                fontSize: fontSize('14px', '13px'),
                boxSizing: 'border-box',
                transition: 'border-color 0.3s',
              }}
              onFocus={(e) => e.target.style.borderColor = primary}
              onBlur={(e) => e.target.style.borderColor = primaryRGBA(0.15)}
            />
          </div>

          <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: vpad('24px','16px'), fontSize: '13px' }}>
            <input type="checkbox" id="agree" style={{ width: '16px', height: '16px', cursor: 'pointer' }} />
            <label htmlFor="agree" style={{ cursor: 'pointer', color: '#516678' }}>
              Get easy solutions through <span style={{ color: primary, fontWeight: '600' }}>WhatsApp</span>
            </label>
          </div>

          <button
            onClick={() => window.open('https://api.whatsapp.com/send/?phone=+8801511404971&text=I%20am%20interested%20in%20Copyright%20Registration%20services%20in%20Bangladesh', '_blank')}
            onMouseEnter={(e) => e.target.style.backgroundColor = primaryDark}
            onMouseLeave={(e) => e.target.style.backgroundColor = primary}
            style={{
              width: '100%',
              padding: fontSize('14px 16px', '12px 14px'),
              backgroundColor: primary,
              color: 'white',
              border: 'none',
              borderRadius: '6px',
              fontSize: fontSize('16px', '14px'),
              fontWeight: '600',
              cursor: 'pointer',
              marginBottom: '12px',
              transition: 'all 0.3s ease',
              minHeight: '48px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              boxSizing: 'border-box'
            }}
          >
            Get Started
          </button>

          <div style={{
            fontSize: fontSize('12px', '11px'),
            color: '#8b98a8',
            textAlign: 'center',
            lineHeight: '1.4'
          }}>
            No spam, just updates. We respect your privacy.
          </div>
        </div>
      </section>

      {/* How it Works Section */}
      <section style={{
        backgroundColor: `${primaryRGBA(0.02)}`,
        padding: vpad('60px 40px','40px 20px'),
        borderTop: `1px solid ${primaryRGBA(0.1)}`,
        overflowX: 'hidden'
      }}>
        <div style={{ maxWidth: '1400px', margin: '0 auto' }}>
          <div style={{ textAlign: 'center', marginBottom: vpad('50px','30px') }}>
            <h2 style={{
              fontSize: fontSize('36px', '24px'),
              fontWeight: '800',
              marginBottom: vpad('16px','12px'),
              background: `linear-gradient(135deg, ${primary} 0%, ${primaryDark} 100%)`,
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              backgroundClip: 'text',
              letterSpacing: '-0.3px'
            }}>
              How it Works
            </h2>
            <p style={{
              fontSize: fontSize('16px', '14px'),
              color: '#516678',
              maxWidth: '700px',
              margin: '0 auto'
            }}>
              A simple, transparent process to protect your creative works in Bangladesh
            </p>
          </div>

          <div style={{
            display: 'grid',
            gridTemplateColumns: responsive ? '1fr' : 'repeat(4, 1fr)',
            gap: vpad('40px','24px'),
            position: 'relative'
          }}>
            {/* Connection Lines - Desktop Only */}
            {!responsive && (
              <div style={{
                position: 'absolute',
                top: '80px',
                left: '12.5%',
                right: '12.5%',
                height: '3px',
                background: `linear-gradient(90deg, ${primary} 0%, ${primary} 25%, transparent 25%, transparent 50%, ${primary} 50%, ${primary} 75%, transparent 75%)`,
                pointerEvents: 'none'
              }}></div>
            )}

            {[
              {
                step: '01',
                title: 'Initial Consultation',
                description: 'Share details about your creative work—type, ownership, and any existing registrations. Our experts provide free guidance.'
              },
              {
                step: '02',
                title: 'Document Preparation',
                description: 'We prepare the application form, declarations, and required documents as per Bangladesh Copyright Act requirements.'
              },
              {
                step: '03',
                title: 'Application Filing',
                description: 'Submit your application to the Copyright Office. We handle online/offline filing and track status throughout the process.'
              },
              {
                step: '04',
                title: 'Registration Certificate',
                description: 'Receive your Registration Certificate. We provide guidance on enforcement, licensing, and commercial use of your work.'
              }
            ].map((item, i) => (
              <div key={i} style={{
                backgroundColor: 'white',
                padding: responsive ? '28px 20px' : '32px 24px',
                borderRadius: '12px',
                border: `1px solid ${primaryRGBA(0.1)}`,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                textAlign: 'center',
                position: 'relative',
                boxShadow: `0 2px 8px ${primaryRGBA(0.04)}`,
                transition: 'all 0.3s ease'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.boxShadow = `0 8px 24px ${primaryRGBA(0.12)}`;
                e.currentTarget.style.transform = 'translateY(-4px)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.boxShadow = `0 2px 8px ${primaryRGBA(0.04)}`;
                e.currentTarget.style.transform = 'translateY(0)';
              }}>
                {/* Step Number Circle */}
                <div style={{
                  width: responsive ? '60px' : '70px',
                  height: responsive ? '60px' : '70px',
                  borderRadius: '50%',
                  background: `linear-gradient(135deg, ${primary}, ${primaryDark})`,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  marginBottom: vpad('20px','16px'),
                  fontSize: fontSize('28px', '24px'),
                  fontWeight: '700',
                  color: 'white',
                  boxShadow: `0 4px 12px ${primaryRGBA(0.3)}`
                }}>
                  {item.step}
                </div>

                <h3 style={{
                  fontSize: fontSize('18px', '16px'),
                  fontWeight: '700',
                  color: primary,
                  marginBottom: '12px',
                  margin: '0 0 12px 0'
                }}>
                  {item.title}
                </h3>

                <p style={{
                  fontSize: fontSize('14px', '13px'),
                  color: '#516678',
                  lineHeight: 1.6,
                  margin: 0
                }}>
                  {item.description}
                </p>

                {/* Right Arrow - Desktop Only */}
                {!responsive && i < 3 && (
                  <div style={{
                    position: 'absolute',
                    right: '-20px',
                    top: '50%',
                    transform: 'translateY(-50%)',
                    fontSize: '24px',
                    color: primary,
                    fontWeight: 'bold',
                    zIndex: 10
                  }}>
                    →
                  </div>
                )}
              </div>
            ))}
          </div>

          <div style={{
            textAlign: 'center',
            marginTop: vpad('50px','32px')
          }}>
            <p style={{
              fontSize: fontSize('15px', '13px'),
              color: '#516678',
              marginBottom: vpad('24px','16px'),
              maxWidth: '600px',
              margin: '0 auto 24px'
            }}>
              Ready to protect your creative work? Contact us today for a free consultation.
            </p>
            <button
              onClick={() => window.open('https://api.whatsapp.com/send/?phone=+8801511404971&text=I%20am%20interested%20in%20Copyright%20Registration%20services%20in%20Bangladesh', '_blank')}
              style={{
                backgroundColor: primary,
                color: 'white',
                border: 'none',
                borderRadius: '8px',
                padding: vpad('14px 40px','12px 32px'),
                fontSize: fontSize('16px', '14px'),
                fontWeight: '600',
                cursor: 'pointer',
                boxShadow: `0 8px 20px ${primaryRGBA(0.15)}`,
                transition: 'all 0.3s ease'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-2px)';
                e.currentTarget.style.boxShadow = `0 12px 28px ${primaryRGBA(0.25)}`;
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = `0 8px 20px ${primaryRGBA(0.15)}`;
              }}
            >
              Start Your Registration Journey
            </button>
          </div>
        </div>
      </section>

      {/* Trust Section */}
      <section style={{
        backgroundColor: '#ffffff',
        padding: vpad('60px 40px','40px 20px'),
        textAlign: 'center',
        borderTop: `1px solid ${primaryRGBA(0.1)}`,
        overflowX: 'hidden'
      }}>
        <div style={{ maxWidth: '1000px', margin: '0 auto' }}>
          <h2 style={{
            fontSize: fontSize('36px', '24px'),
            fontWeight: '800',
            marginBottom: vpad('16px','12px'),
            background: `linear-gradient(135deg, ${primary} 0%, ${primaryDark} 100%)`,
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            backgroundClip: 'text',
            letterSpacing: '-0.3px'
          }}>
            Trusted on Google & Trustpilot — JK Associates. Bangladesh's Trusted Copyright Platform
          </h2>
          <p style={{
            fontSize: fontSize('16px', '14px'),
            color: '#516678',
            marginBottom: vpad('40px','20px')
          }}>
            A leading copyright platform delivering reliable and expert services nationwide across Bangladesh since 2011
          </p>

          <div style={{
            display: 'grid',
            gridTemplateColumns: responsive ? '1fr 1fr' : 'repeat(4, 1fr)',
            gap: vpad('40px','20px')
          }}>
            {[
              { text: 'Google Reviews', rating: '⭐⭐⭐⭐⭐ 5/5' },
              { text: 'Trustpilot Reviews', rating: '⭐⭐⭐⭐ 4.8/5' },
              { text: 'Local Reviews', rating: '⭐⭐⭐⭐ 4.8/5' },
              { text: 'Verified Clients (BD)', rating: '10,000+' }
            ].map((item, i) => (
              <div key={i} style={{ 
                padding: vpad('24px', '16px'), 
                backgroundColor: `${primaryRGBA(0.03)}`, 
                borderRadius: '8px', 
                border: `1px solid ${primaryRGBA(0.1)}`,
                transition: 'all 0.3s ease',
                minHeight: responsive ? 'auto' : '140px',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center'
              }}>
                <div style={{ fontSize: fontSize('14px', '12px'), color: '#516678', marginBottom: '8px', fontWeight: '500' }}>{item.text}</div>
                <div style={{ fontSize: fontSize('16px', '14px'), fontWeight: '600', color: primary }}>{item.rating}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Types of Creative Work */}
      <section style={{
        backgroundColor: `${primaryRGBA(0.02)}`,
        padding: vpad('60px 40px','40px 20px'),
        overflowX: 'hidden'
      }}>
        <div style={{ maxWidth: '1400px', margin: '0 auto' }}>
          <h2 style={{
            fontSize: fontSize('36px', '24px'),
            fontWeight: '800',
            marginBottom: vpad('48px','24px'),
            textAlign: 'center',
            background: `linear-gradient(135deg, ${primary} 0%, ${primaryDark} 100%)`,
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            backgroundClip: 'text',
            letterSpacing: '-0.3px'
          }}>
            Types of Creative Work
          </h2>

          <div style={{
            display: 'grid',
            gridTemplateColumns: responsive ? '1fr' : 'repeat(3, 1fr)',
            gap: vpad('30px','20px')
          }}>
            {[
              {
                icon: <FaMusic size={50} color={primary} />,
                title: 'Sound Recording',
                desc: 'Music, soundtracks & sound recordings with underlying compositions',
                cta: 'Protect Your Sound Recording',
                color: primary
              },
              {
                icon: <FaBook size={50} color={primary} />,
                title: 'Literary Work',
                desc: 'Books, fiction, non-fiction, catalogs, ad copy, directories & poetry',
                cta: 'Register Literary Work',
                color: primary
              },
              {
                icon: <FaPaintBrush size={50} color={primary} />,
                title: 'Artistic Works',
                desc: 'Paintings, photographs, sculptures, drawings & visual designs',
                cta: 'Register Artistic Works',
                color: primary
              },
              {
                icon: <FaFilm size={50} color={primary} />,
                title: 'Audiovisual Works',
                desc: 'Films, animations, videos, documentaries & multimedia productions',
                cta: 'Register Audiovisual Works',
                color: primary
              },
              {
                icon: <FaMusic size={50} color={primary} />,
                title: 'Musical Works',
                desc: 'Original musical compositions with or without lyrics',
                cta: 'Register Musical Work',
                color: primary
              },
              {
                icon: <FaStar size={50} color={primary} />,
                title: 'Work of Performing Arts',
                desc: 'Theatre, dance, circus, mime & live performance recordings',
                cta: 'Register Performance Works',
                color: primary
              },
              {
                icon: <FaBook size={50} color={primary} />,
                title: 'Dramatic Works',
                desc: 'Screenplays, plays, scripts & dramatic literary compositions',
                cta: 'Register Dramatic Work',
                color: primary
              },
              {
                icon: <FaMusic size={50} color={primary} />,
                title: 'Musical Compositions',
                desc: 'Sheet music, original compositions & melodic arrangements',
                cta: 'Register Composition',
                color: primary
              },
              {
                icon: <FaCode size={50} color={primary} />,
                title: 'Software',
                desc: 'Computer programs, applications, source code & databases',
                cta: 'Register Software',
                color: primary
              }
            ].map((work, i) => (
              <div key={i} style={{
                backgroundColor: 'white',
                padding: responsive ? '24px' : '32px',
                borderRadius: '8px',
                border: `1px solid ${primaryRGBA(0.1)}`,
                display: 'flex',
                flexDirection: 'column',
                gap: '16px'
              }}>
                <div style={{ color: work.color, display: 'flex', justifyContent: 'center' }}>
                  {work.icon}
                </div>
                <h3 style={{
                  fontSize: fontSize('18px', '16px'),
                  fontWeight: '700',
                  color: primary,
                  textAlign: 'center',
                  margin: 0
                }}>
                  {work.title}
                </h3>
                <p style={{
                  fontSize: fontSize('14px', '13px'),
                  color: '#516678',
                  textAlign: 'center',
                  margin: 0,
                  lineHeight: 1.5
                }}>
                  {work.desc}
                </p>
                <button style={{
                  marginTop: 'auto',
                  padding: fontSize('10px 16px', '8px 12px'),
                  backgroundColor: primary,
                  color: 'white',
                  border: 'none',
                  borderRadius: '4px',
                  fontSize: fontSize('13px', '12px'),
                  fontWeight: '600',
                  cursor: 'pointer',
                  transition: 'all 0.3s ease',
                  minHeight: '36px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}
                onMouseEnter={(e) => e.target.style.backgroundColor = primaryDark}
                onMouseLeave={(e) => e.target.style.backgroundColor = primary}
                >
                  {work.cta}
                </button>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* IPR Enforcement & Protection */}
      <section style={{
        background: `linear-gradient(135deg, ${primaryRGBA(0.03)} 0%, ${accentRGBA(0.02)} 100%)`,
        padding: vpad('60px 40px','40px 20px'),
        borderLeft: responsive ? '4px solid ' + accent : `6px solid ${accent}`,
        position: 'relative',
        overflow: 'hidden',
        boxShadow: `0 10px 40px ${accentRGBA(0.08)}`
      }}>
        {/* Background accent - left */}
        <div style={{
          position: 'absolute',
          top: '-50px',
          right: '-50px',
          width: '200px',
          height: '200px',
          background: `radial-gradient(circle, ${accentRGBA(0.08)}, transparent)`,
          borderRadius: '50%',
          pointerEvents: 'none'
        }}></div>

        {/* Background accent - right */}
        <div style={{
          position: 'absolute',
          bottom: '-80px',
          left: '-80px',
          width: '250px',
          height: '250px',
          background: `radial-gradient(circle, ${accentRGBA(0.05)}, transparent)`,
          borderRadius: '50%',
          pointerEvents: 'none'
        }}></div>

        <div style={{ maxWidth: '1400px', margin: '0 auto', position: 'relative', zIndex: 1 }}>
          {/* Critical Alert Badge */}
          <div style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: '8px',
            backgroundColor: `${accentRGBA(0.15)}`,
            padding: '12px 18px',
            borderRadius: '8px',
            marginBottom: vpad('28px','20px'),
            fontSize: fontSize('13px', '12px'),
            color: accent,
            fontWeight: '700',
            border: `1px solid ${accentRGBA(0.3)}`,
            letterSpacing: '0.5px',
            textTransform: 'uppercase',
            boxShadow: `0 2px 8px ${accentRGBA(0.12)}`
          }}>
            <span style={{ fontSize: '18px', animation: 'pulse 2s infinite' }}>●</span>
            <span>Premium: Enforce Your Rights</span>
          </div>

          <div style={{
            display: 'grid',
            gridTemplateColumns: responsive ? '1fr' : '1fr 1fr',
            gap: vpad('60px','30px'),
            alignItems: 'center'
          }}>
            {/* Left Content */}
            <div>
              <h2 style={{
                fontSize: fontSize('40px', '28px'),
                fontWeight: '900',
                marginBottom: vpad('24px','16px'),
                background: `linear-gradient(135deg, ${accent} 0%, ${primaryDark} 50%, ${primary} 100%)`,
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                backgroundClip: 'text',
                lineHeight: 1.2,
                letterSpacing: '-0.5px'
              }}>
                Enforce Your IP Rights
              </h2>
              <p style={{
                fontSize: fontSize('16px', '14px'),
                color: '#424242',
                lineHeight: 1.8,
                marginBottom: '20px',
                fontWeight: '500'
              }}>
                Registration alone isn't enough. Protect your creative assets from infringement with our comprehensive IPR Enforcement services. We help you monitor, detect, and take decisive action against unauthorized use.
              </p>
              
              <div style={{ marginBottom: vpad('24px','16px') }}>
                {[
                  'Monitor and identify unauthorized use of your copyrighted works',
                  'Cease & Desist notices and legal warnings',
                  'Counterfeit investigation and enforcement',
                  'Digital rights management and online protection',
                  'Court representation for infringement cases',
                  'Settlement negotiations and licensing agreements'
                ].map((item, i) => (
                  <div key={i} style={{
                    display: 'flex',
                    gap: '12px',
                    marginBottom: vpad('12px','8px'),
                    fontSize: fontSize('14px', '13px'),
                    color: '#23384a'
                  }}>
                    <span style={{ color: accent, fontWeight: 'bold', flexShrink: 0 }}>✓</span>
                    <span>{item}</span>
                  </div>
                ))}
              </div>

              <p style={{
                fontSize: fontSize('14px', '12px'),
                backgroundColor: `${accentRGBA(0.08)}`,
                padding: '16px',
                borderRadius: '8px',
                borderLeft: `3px solid ${accent}`,
                color: '#516678',
                lineHeight: 1.6,
                marginBottom: vpad('24px','16px')
              }}>
                <strong style={{ color: primary }}>Did you know?</strong> Without enforcement, even a registered copyright can be vulnerable to infringement. Timely action can prevent significant losses and establish market dominance.
              </p>

              <button
                onClick={() => window.open('https://api.whatsapp.com/send/?phone=%2B8801511404971&text=I%20need%20urgent%20IPR%20Enforcement%20support%20for%20my%20copyright%20in%20Bangladesh', '_blank')}
                style={{
                  backgroundColor: primary,
                  color: 'white',
                  border: 'none',
                  borderRadius: '8px',
                  padding: vpad('16px 36px','14px 28px'),
                  fontSize: fontSize('16px', '14px'),
                  fontWeight: '700',
                  cursor: 'pointer',
                  boxShadow: `0 8px 24px ${primaryRGBA(0.25)}`,
                  transition: 'all 0.3s ease',
                  letterSpacing: '0.5px',
                  textTransform: 'uppercase'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-3px)';
                  e.currentTarget.style.boxShadow = `0 12px 32px ${primaryRGBA(0.35)}`;
                  e.currentTarget.style.backgroundColor = primaryDark;
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = `0 8px 24px ${primaryRGBA(0.25)}`;
                  e.currentTarget.style.backgroundColor = primary;
                }}
              >
                Get Enforcement Support
              </button>
            </div>

            {/* Right Content - Stats Cards */}
            <div style={{
              display: 'grid',
              gridTemplateColumns: responsive ? '1fr' : 'repeat(2, 1fr)',
              gap: vpad('24px','16px')
            }}>
              {[
                {
                  icon: '⚖️',
                  title: 'Legal Action',
                  desc: 'Court cases & litigation support for IP infringement',
                  color: accent
                },
                {
                  icon: '🔍',
                  title: 'Investigation',
                  desc: 'Counterfeit detection & market monitoring services',
                  color: primaryLight
                },
                {
                  icon: '📱',
                  title: 'Digital Protection',
                  desc: 'Online infringement detection & takedown notices',
                  color: accent
                },
                {
                  icon: '🤝',
                  title: 'Settlements',
                  desc: 'Negotiate licensing & compensation agreements',
                  color: primaryLight
                }
              ].map((item, i) => (
                <div key={i} style={{
                  backgroundColor: 'white',
                  padding: vpad('28px','22px'),
                  borderRadius: '12px',
                  border: `2px solid ${item.color}`,
                  boxShadow: `0 4px 16px ${item.color === accent ? accentRGBA(0.15) : primaryRGBA(0.12)}`,
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  textAlign: 'center',
                  gap: '14px',
                  transition: 'all 0.3s ease',
                  position: 'relative',
                  overflow: 'hidden'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-6px)';
                  e.currentTarget.style.boxShadow = `0 16px 32px ${item.color === accent ? accentRGBA(0.25) : primaryRGBA(0.2)}`;
                  e.currentTarget.style.borderColor = item.color;
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = `0 4px 16px ${item.color === accent ? accentRGBA(0.15) : primaryRGBA(0.12)}`;
                }}>
                  {/* Background shimmer */}
                  <div style={{
                    position: 'absolute',
                    top: 0,
                    left: '-100%',
                    width: '100%',
                    height: '100%',
                    background: `linear-gradient(90deg, transparent, ${item.color}15, transparent)`,
                    pointerEvents: 'none'
                  }}></div>

                  <div style={{ fontSize: fontSize('44px', '36px'), position: 'relative', zIndex: 1 }}>
                    {item.icon}
                  </div>
                  <h3 style={{
                    fontSize: fontSize('18px', '15px'),
                    fontWeight: '700',
                    color: item.color,
                    margin: 0,
                    position: 'relative',
                    zIndex: 1
                  }}>
                    {item.title}
                  </h3>
                  <p style={{
                    fontSize: fontSize('13px', '12px'),
                    color: '#555',
                    margin: 0,
                    lineHeight: 1.6,
                    position: 'relative',
                    zIndex: 1,
                    fontWeight: '500'
                  }}>
                    {item.desc}
                  </p>
                </div>
              ))}

              {/* Alert Box */}
              <div style={{
                gridColumn: responsive ? 'auto' : '1 / -1',
                backgroundColor: `${accentRGBA(0.08)}`,
                padding: vpad('24px','18px'),
                borderRadius: '10px',
                border: `2px solid ${accent}`,
                display: 'flex',
                gap: '14px',
                alignItems: 'flex-start',
                boxShadow: `0 4px 12px ${accentRGBA(0.15)}`
              }}>
                <span style={{ fontSize: '24px', flexShrink: 0, animation: 'pulse 2s infinite' }}>⚠️</span>
                <div>
                  <p style={{
                    fontSize: fontSize('14px', '13px'),
                    color: primary,
                    fontWeight: '700',
                    margin: '0 0 6px 0',
                    letterSpacing: '0.3px'
                  }}>
                    Act Fast
                  </p>
                  <p style={{
                    fontSize: fontSize('13px', '12px'),
                    color: '#555',
                    margin: 0,
                    lineHeight: 1.6,
                    fontWeight: '500'
                  }}>
                    Early intervention is critical. Every day of delay strengthens the infringer's position. Contact us immediately upon discovering unauthorized use.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Copyright Registration Info */}
      <section style={{
        backgroundColor: 'white',
        padding: vpad('60px 40px','40px 20px'),
        overflowX: 'hidden'
      }}>
        <div style={{ maxWidth: '1400px', margin: '0 auto' }}>
          <div style={{
            display: 'grid',
            gridTemplateColumns: responsive ? '1fr' : '1fr 1fr',
            gap: vpad('60px','30px'),
            alignItems: 'center'
          }}>
            <div>
              <h2 style={{
                fontSize: fontSize('32px', '24px'),
                fontWeight: '800',
                marginBottom: vpad('20px','12px'),
                background: 'linear-gradient(135deg, #1e88e5 0%, #0d5cb8 100%)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                backgroundClip: 'text',
                letterSpacing: '-0.3px'
              }}>
                Copyright Registration in Bangladesh
              </h2>
              <p style={{
                fontSize: fontSize('15px', '13px'),
                color: '#516678',
                lineHeight: 1.8,
                marginBottom: '16px'
              }}>
                Copyright registration in Bangladesh is administered under the Copyright Act, 2000. Registration creates a public record of ownership, helps in enforcement, and is often required for licensing, distribution and commercial use.
              </p>
              <p style={{
                fontSize: fontSize('15px', '13px'),
                color: '#516678',
                lineHeight: 1.8
              }}>
                JK Associates assists with preparing documents, filing online or offline applications, tracking government processing, and obtaining the Registration Certificate on your behalf.
              </p>
            </div>
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%', minHeight: responsive ? '250px' : '400px' }}>
              <LazyImg img={{ src: headerImg, alt: "Copyright Registration Bangladesh" }} style={{ maxWidth: '100%', height: 'auto', objectFit: 'contain' }} />
            </div>
          </div>
        </div>
      </section>

      {/* What is Copyright */}
      <section style={{
        backgroundColor: `${primaryRGBA(0.02)}`,
        padding: vpad('60px 40px','40px 20px'),
        overflowX: 'hidden'
      }}>
        <div style={{ maxWidth: '1400px', margin: '0 auto' }}>
          <div style={{
            display: 'grid',
            gridTemplateColumns: responsive ? '1fr' : '1fr 1fr',
            gap: vpad('60px','30px'),
            alignItems: 'center'
          }}>
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%', minHeight: responsive ? '250px' : '300px' }}>
              <LazyImg img={{ src: copyright, alt: "Copyright Registration Bangladesh" }} style={{ maxWidth: '100%', height: 'auto', objectFit: 'contain' }} />
            </div>
            <div>
              <h2 style={{
                fontSize: fontSize('32px', '24px'),
                fontWeight: '800',
                marginBottom: vpad('20px','12px'),
                background: 'linear-gradient(135deg, #1e88e5 0%, #0d5cb8 100%)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                backgroundClip: 'text',
                letterSpacing: '-0.3px'
              }}>
                What is Copyright?
              </h2>
              <p style={{
                fontSize: fontSize('15px', '13px'),
                color: '#516678',
                lineHeight: 1.8
              }}>
                Copyright grants creators exclusive rights over the expression of original works — literary, dramatic, musical, artistic, cinematographic, and software. It does not protect ideas themselves but protects how ideas are expressed.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Importance of Copyright */}
      <section style={{
        backgroundColor: 'white',
        padding: vpad('60px 40px','40px 20px'),
        marginBottom: vpad('40px','18px'),
        overflowX: 'hidden',
      }}>
        <div style={{ maxWidth: '1400px', margin: '0 auto' }}>
          <div style={{
            display: 'grid',
            gridTemplateColumns: responsive ? '1fr' : '1fr 1fr',
            gap: vpad('60px','30px'),
            alignItems: 'center'
          }}>
            <div>
              <h2 style={{
                fontSize: fontSize('32px', '24px'),
                fontWeight: '800',
                marginBottom: vpad('20px','12px'),
                background: 'linear-gradient(135deg, #1e88e5 0%, #0d5cb8 100%)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                backgroundClip: 'text',
                letterSpacing: '-0.3px'
              }}>
                Importance of Copyright Registration
              </h2>
              <p style={{
                fontSize: fontSize('15px', '13px'),
                color: '#516678',
                lineHeight: 1.8,
                marginBottom: '16px'
              }}>
                Registration provides an official record that helps in enforcement, licensing, and establishing ownership. It strengthens remedies available in courts and supports commercialisation of creative works.
              </p>
              <p style={{
                fontSize: fontSize('15px', '13px'),
                color: '#516678',
                lineHeight: 1.8
              }}>
                JK Associates guides creators through documentation, checking ownership, and filing to ensure a smooth registration process in Bangladesh.
              </p>
            </div>
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%', minHeight: responsive ? '250px' : '300px' }}>
              <LazyImg img={{ src: importantCopyright, alt: "Copyright Registration Bangladesh" }} style={{ maxWidth: '100%', height: 'auto', objectFit: 'contain' }} />
            </div>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section style={{
        backgroundColor: `${primaryRGBA(0.02)}`,
        padding: vpad('60px 40px','40px 20px'),
        overflowX: 'hidden'
      }}>
        <div style={{ maxWidth: '1000px', margin: '0 auto' }}>
          <h2 style={{
            fontSize: fontSize('32px', '24px'),
            fontWeight: '800',
            marginBottom: vpad('40px','20px'),
            textAlign: 'center',
            background: 'linear-gradient(135deg, #1e88e5 0%, #0d5cb8 100%)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            backgroundClip: 'text',
            letterSpacing: '-0.3px'
          }}>
            Frequently Asked Questions
          </h2>
          <Faq items={faqItems} />
        </div>
      </section>
{/* Testimonials block unchanged internally; spacing values standardized above */}
      <section style={{
        backgroundColor: 'white',
        padding: vpad('60px 40px','40px 20px'),
        color: primary,
        border: `2px solid ${primaryRGBA(0.15)}`,
        borderRadius: '12px',
        marginTop: vpad('40px','20px'),
        marginBottom: vpad('40px','18px'),
        overflow: 'hidden',
        overflowX: 'hidden',
        position: 'relative'
      }}>
        
        <div style={{ position: 'relative', zIndex: 1 }}>
          <div style={{ textAlign: 'center', marginBottom: vpad('50px','24px') }}>
            <div style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '10px',
              marginBottom: vpad('15px','10px')
            }}>
              <div style={{ width: '40px', height: '2px', backgroundColor: '#eaf5ff' }}></div>
              <span style={{
                fontSize: fontSize('16px', '12px'),
                fontWeight: '600',
                letterSpacing: '2px',
                textTransform: 'uppercase',
                color: '#0f2a44'
              }}>Client Testimonials</span>
              <div style={{ width: '40px', height: '2px', backgroundColor: '#eaf5ff' }}></div>
            </div>

            <h2 style={{
              fontSize: fontSize('40px', '24px'),
              marginBottom: vpad('15px','10px'),
              fontWeight: '800',
              lineHeight: 1.3,
              background: 'linear-gradient(135deg, #1e88e5 0%, #0d5cb8 100%)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              backgroundClip: 'text',
              letterSpacing: '-0.3px'
            }}>
              What Our Clients Say
            </h2>

            <p style={{
              fontSize: fontSize('16px', '13px'),
              maxWidth: '600px',
              margin: '0 auto',
              opacity: 0.95,
              lineHeight: 1.6,
              color: '#516678'
            }}>
              Join hundreds of satisfied creators across Bangladesh who have protected their original works with JK Associates
            </p>
          </div>

          <div style={{
            maxWidth: '1200px',
            margin: '0 auto',
            marginBottom: vpad('18px','12px')
          }}>
            <Testimonial isResponsive={responsive} whiteTheme />
          </div>

          <div style={{
            display: 'grid',
            gridTemplateColumns: responsive ? '1fr' : 'repeat(3, 1fr)',
            gap: vpad('40px','20px'),
            marginTop: vpad('40px','24px'),
            paddingTop: vpad('40px','20px'),
            borderTop: '1px solid rgba(234,245,255,0.6)'
          }}>
            {[
              { number: '500+', label: 'Successful Registrations' },
              { number: '98%', label: 'Client Satisfaction Rate' },
              { number: '15+', label: 'Years of Experience' }
            ].map((stat, i) => (
              <div key={i} style={{ textAlign: 'center' }}>
                <h3 style={{
                  fontSize: fontSize('32px', '20px'),
                  fontWeight: '700',
                  margin: '0 0 8px 0',
                  textShadow: '0 2px 4px rgba(0,0,0,0.04)',
                  color: '#0f2a44'
                }}>
                  {stat.number}
                </h3>
                <p style={{
                  fontSize: fontSize('14px', '12px'),
                  margin: 0,
                  opacity: 0.9,
                  fontWeight: '500',
                  color: '#516678'
                }}>
                  {stat.label}
                </p>
              </div>
            ))}
          </div>

          <div style={{
            textAlign: 'center',
            marginTop: vpad('30px','16px')
          }}>
            <button
              onClick={() => window.open("https://www.google.com/maps/place/JK+Associates+%7C+Income+Tax+%7C+VAT+%7C+Company+Registration+%7C+Copyright+%7C+Trademark/@23.7927683,90.3719291,17z", '_blank')}
              style={{
                backgroundColor: '#ffffff',
                color: primary,
                border: 'none',
                borderRadius: '8px',
                padding: vpad('16px 48px','12px 32px'),
                fontSize: fontSize('16px', '13px'),
                fontWeight: '700',
                cursor: 'pointer',
                transition: 'all 0.3s ease',
                boxShadow: '0 8px 24px rgba(14,82,163,0.08)',
                letterSpacing: '0.5px'
              }}
            >
              Visit Our Office (Dhaka)
            </button>
          </div>
        </div>
      </section>

      {/* Timeline & Fees Section */}
      <section style={{
        backgroundColor: 'white',
        padding: vpad('48px 40px','24px 12px'),
        marginTop: vpad('40px','20px'),
        maxWidth: '100%',
        margin: 'auto',
        marginBottom: vpad('40px','18px'),
        borderRadius: '14px',
        border: `1px solid ${primaryRGBA(0.12)}`,
        overflow: 'hidden',
        boxShadow: subtleShadow
      }}>
        <div style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: '20px',
          flexDirection: responsive ? 'column' : 'row',
          marginBottom: vpad('28px','16px')
        }}>
          <div style={{ textAlign: responsive ? 'center' : 'left', flex: 1 }}>
            <h2 style={{
              fontSize: fontSize('28px', '18px'),
              background: `linear-gradient(135deg, ${primary} 0%, ${primaryDark} 100%)`,
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              backgroundClip: 'text',
              margin: 0,
              fontWeight: '800',
              letterSpacing: '-0.3px'
            }}>Timeline & Fees</h2>
            <p style={{
              fontSize: fontSize('14px', '13px'),
              color: '#516678',
              marginTop: '8px',
              maxWidth: responsive ? '100%' : '720px',
              opacity: 0.95
            }}>
              Clear, transparent pricing and realistic timelines for copyright registration in Bangladesh. We handle formalities so you can focus on creativity.
            </p>
          </div>

          <div style={{
            display: 'inline-flex',
            gap: '12px',
            alignItems: 'center',
            justifyContent: 'center'
          }}>
            <div style={{
              background: primaryGradient,
              color: primary,
              padding: '10px 14px',
              borderRadius: '999px',
              fontWeight: 700,
              fontSize: fontSize('16px','14px'),
              border: `1px solid ${primaryRGBA(0.12)}`
            }}>
              Free Consultation
            </div>
            <div style={{
              background: 'white',
              color: accent,
              padding: '10px 14px',
              borderRadius: '999px',
              fontWeight: 700,
              fontSize: fontSize('16px','14px'),
              border: `1px dashed ${accentRGBA(0.3)}`
            }}>
              No Hidden Charges
            </div>
          </div>
        </div>

        <div style={{
          display: 'grid',
          gridTemplateColumns: responsive ? '1fr' : 'repeat(3, 1fr)',
          gap: responsive ? '16px' : '22px',
          alignItems: 'stretch'
        }}>
          {/* ...cards unchanged */}
          {[
            {
              icon: <FaRegClock size={responsive ? 28 : 36} color={primary} />,
              title: 'Timeline',
              value: 'Approx. 6–12 months',
              note: 'From filing to registration (depends on government processing & oppositions).'
            },
            {
              icon: <FaFileContract size={responsive ? 28 : 36} color={primary} />,
              title: 'Government Fees',
              value: 'Starts from BDT 6,000',
              note: 'Fees vary by class & application type. Exact estimate provided after document review.'
            },
            {
              icon: <FaShieldAlt size={responsive ? 28 : 36} color={primary} />,
              title: 'Professional Fees',
              value: 'Competitive & tailored',
              note: 'Transparent, fixed-fee packages and installment plans available for creators.'
            }
          ].map((item, i) => (
            <div key={i} style={{
              background: `linear-gradient(180deg, #ffffff, ${primaryRGBA(0.02)})`,
              borderRadius: '12px',
              padding: vpad('20px', '14px'),
              border: `1px solid ${primaryRGBA(0.12)}`,
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'space-between',
              boxShadow: `0 6px 18px ${primaryRGBA(0.06)}`,
              transition: 'transform 160ms ease, box-shadow 160ms ease',
              cursor: 'default'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'translateY(-6px)';
              e.currentTarget.style.boxShadow = `0 18px 40px ${primaryRGBA(0.12)}`;
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.boxShadow = `0 6px 18px ${primaryRGBA(0.06)}`;
            }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '14px' }}>
                <div style={{
                  width: responsive ? '48px' : '60px',
                  height: responsive ? '48px' : '60px',
                  borderRadius: '12px',
                  background: `linear-gradient(135deg, ${primaryRGBA(0.1)}, ${primaryRGBA(0.03)})`,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  flexShrink: 0
                }}>
                  {item.icon}
                </div>
                <div style={{ textAlign: 'left' }}>
                  <h3 style={{
                    fontSize: fontSize('18px','15px'),
                    margin: 0,
                    color: primary,
                    fontWeight: 700
                  }}>{item.title}</h3>
                  <div style={{ marginTop: '6px', display: 'flex', gap: '8px', alignItems: 'baseline' }}>
                    <strong style={{ fontSize: fontSize('20px','16px'), color: primary }}>{item.value}</strong>
                  </div>
                </div>
              </div>

              <p style={{
                marginTop: '12px',
                marginBottom: 0,
                color: '#5b7fa7',
                fontSize: fontSize('14px','12px'),
                lineHeight: 1.5
              }}>{item.note}</p>
            </div>
          ))}
        </div>

        <div style={{
          marginTop: vpad('22px','12px'),
          display: 'flex',
          gap: '16px',
          justifyContent: 'center',
          flexDirection: responsive ? 'column' : 'row',
          alignItems: 'center'
        }}>
          <button
            onClick={() => window.open('https://api.whatsapp.com/send/?phone=+8801511404971&text=I%20am%20interested%20in%20Copyright%20Registration%20services%20in%20Bangladesh', '_blank')}
            style={{
              backgroundColor: primary,
              color: 'white',
              border: 'none',
              borderRadius: '10px',
              padding: vpad('10px 20px', '12px 28px'),
              fontSize: fontSize('16px','14px'),
              fontWeight: 700,
              cursor: 'pointer',
              boxShadow: `0 10px 28px ${primaryRGBA(0.2)}`,
              transition: 'all 150ms ease',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '8px',
              minHeight: '44px',
              minWidth: responsive ? '100%' : 'auto'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'translateY(-3px)';
              e.currentTarget.style.boxShadow = `0 15px 36px ${primaryRGBA(0.3)}`;
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.boxShadow = `0 10px 28px ${primaryRGBA(0.2)}`;
            }}
          >
            💬 WhatsApp
          </button>

          <button
            onClick={() => window.location.href = 'mailto:info@jkassociates.com?subject=Copyright%20Registration%20Inquiry&body=I%20am%20interested%20in%20Copyright%20Registration%20services%20in%20Bangladesh'}
            style={{
              backgroundColor: accent,
              color: 'white',
              border: 'none',
              borderRadius: '10px',
              padding: vpad('10px 20px', '12px 28px'),
              fontSize: fontSize('16px','14px'),
              fontWeight: 700,
              cursor: 'pointer',
              boxShadow: `0 10px 28px ${accentRGBA(0.2)}`,
              transition: 'all 150ms ease',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '8px',
              minHeight: '44px',
              minWidth: responsive ? '100%' : 'auto'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'translateY(-3px)';
              e.currentTarget.style.boxShadow = `0 15px 36px ${accentRGBA(0.3)}`;
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.boxShadow = `0 10px 28px ${accentRGBA(0.2)}`;
            }}
          >
            📧 Email
          </button>

          <button
            style={{
              backgroundColor: 'transparent',
              color: primary,
              border: `2px solid ${primary}`,
              borderRadius: '10px',
              padding: vpad('10px 20px', '12px 28px'),
              fontSize: fontSize('16px','14px'),
              fontWeight: 700,
              cursor: 'pointer',
              transition: 'all 150ms ease',
              minHeight: '44px',
              minWidth: responsive ? '100%' : 'auto'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = primary;
              e.currentTarget.style.color = 'white';
              e.currentTarget.style.transform = 'translateY(-3px)';
              e.currentTarget.style.boxShadow = `0 10px 28px ${primaryRGBA(0.2)}`;
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = 'transparent';
              e.currentTarget.style.color = primary;
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.boxShadow = 'none';
            }}
          >
            Get a Detailed Quote
          </button>
        </div>
      </section>
    </main>
  );
}